<svg viewBox="0 0 10 11" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path id="svg_1" fill="#CACCCF" d="m4.58334,0l4.58332,4.41667l-9.16666,0l4.58334,-4.41667z" clip-rule="evenodd"
        fill-rule="evenodd" />
    <path id="svg_2" fill="#313336" d="m4.58335,10.83337l-4.58333,-4.4167l9.16664,0l-4.58331,4.4167z"
        clip-rule="evenodd" fill-rule="evenodd" />

</svg>
